<template>
  <el-container direction="vertical" class="forget-page">
    <!-- 全屏背景视频（与登录页保持一致） -->
    <video
      class="bg-video"
      src="https://mr-futrue.oss-accelerate.aliyuncs.com/PC/login-video.mp4"
      autoplay
      :muted="true"
      loop
      playsinline
      webkit-playsinline
      x5-playsinline
      preload="auto"
    ></video>

    <!-- 中间偏右的高斯模糊玻璃卡片 -->
    <div class="login-shell">
      <div class="glass-card">
      <el-form
        :model="forgetForm"
        :rules="rules"
        ref="forgetForm"
        label-position="left"
        label-width="0px"
        class="demo-ruleForm login-container"
      >
        <h3 class="title">重置您的账户密码</h3>
        <el-form-item prop="phone">
          <el-input
            id="input2"
            type="text"
            v-model="forgetForm.phone"
            auto-complete="off"
            clearable
            placeholder="请输入登录手机号"
            @input="phoneInp"
          >
            <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <div class="codeBox">
            <el-input
              id="input2"
              type="text"
              v-model="forgetForm.code"
              auto-complete="off"
              placeholder="请输入短信验证码"
              clearable
              :disabled="disInput"
            >
              <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
            </el-input>
            <el-button
              class="getCodeBtn"
              @click="getCode"
              type="primary"
              :disabled="disBtn"
            >
              {{ codeText }}{{ codeText2 }}
            </el-button>
          </div>
        </el-form-item>
        <el-form-item prop="pwd" size="medium">
          <el-input
            id="input2"
            type="text"
            v-model="forgetForm.pwd"
            auto-complete="off"
            placeholder="请输入新密码"
            show-password
            clearable
            maxlength="11"
          >
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input> </el-form-item
        ><el-form-item prop="surePwd" size="medium">
          <el-input
            id="input2"
            type="text"
            v-model="forgetForm.surePwd"
            auto-complete="off"
            placeholder="确认密码"
            show-password
            clearable
            maxlength="11"
          >
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </el-form-item>

        <el-form-item class="center">
          <button
            class="btnlogin"
            round
            type="primary"
            @click="submitForm('forgetForm')"
          >
            重置密码
          </button>
        </el-form-item>
        <div class="tr">
          <span class="toreturn" @click="goLogin">< 返回登录页面</span>
        </div>
      </el-form>
      </div>
    </div>
    <div class="biaoshi">
      @ 2005-2021 MR.FUTURE未来先生版权所有，并保留所有权 | 蜀CP备2021032368号-2
    </div>
  </el-container>
</template>

<script>
//import NProgress from 'nprogress'
import { validateTelephone, validatePass, validateCode } from "../utils/tool";
import { setCookieMinute } from "../utils/cookie";
import jsonp from "jsonp";
import { handleConfirm, handleAlert } from "../components/UtilsIf";
export default {
  data() {
    // 手机号验证
    const addPhone = (rule, value, callback) => {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        callback(new Error("请填写联系方式"));
      } else if (!reg.test(value)) {
        callback(new Error("手机号格式不正确，请重新输入"));
      } else {
        callback();
      }
    };
    // 短信验证码
    const addCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写短信验证码"));
      } else {
        callback();
      }
    };

    // 登录密码
    const addPwd = (rule, value, callback) => {
      var reg = /^.*(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]){6,11}/;
      if (!value) {
        callback(new Error("请填写登录密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码必须包含数字，大小写字母，长度在6-11位"));
      } else {
        callback();
      }
    };

    // 确认登录密码
    const addSurePwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请确认密码"));
      } else if (value != this.forgetForm.pwd) {
        callback(new Error("两次密码不一致，请重新输入"));
      } else {
        callback();
      }
    };
    return {
      logining: false,

      forgetForm: {
        phone: "",
        code: "",
        pwd: "",
        surePwd: "",
      },
      disInput: true,
      disBtn: true,
      codeText: "获取验证码",
      codeText2: "",
      rules: {
        phone: [{ required: true, validator: addPhone, trigger: "blur" }],
        code: [{ required: true, validator: addCode, trigger: "blur" }],
        pwd: [{ required: true, validator: addPwd, trigger: "blur" }],
        surePwd: [{ required: true, validator: addSurePwd, trigger: "blur" }],
      },
      checked: true,
      time: 0,
    };
  },
  created() {},
  methods: {
    phoneInp() {
      var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg.test(this.forgetForm.phone)) {
        this.disBtn = true;
        this.disInput = true;
      } else {
        this.disBtn = false;
      }
    },
    goLogin() {
      this.$router.push("/Login");
    },
    getCode() {
      this.$api.admincustomerq
        .getNote({ phone: this.forgetForm.phone })
        .then((res) => {
          if (res === true) {
            this.$message({
              message: "短信已发送，请注意查收",
              type: "success",
            });
            this.disInput = false;
            this.disBtn = true;
            this.codeText = 60;
            this.codeText2 = "s后重新获取";
            let timer = setInterval(() => {
              this.codeText--;
              if (this.codeText == 0) {
                this.codeText = "重新获取";
                this.codeText2 = "";
                this.disBtn = false;
                clearInterval(timer);
              }
            }, 1000);
          }
        });
    },

    handleReset() {
      this.$refs.loginForm.resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // handleAlert("保存成功", "success");
          this.$api.admincustomerq
            .resetPwd({
              code: this.forgetForm.code,
              password: this.forgetForm.pwd,
              phone: this.forgetForm.phone,
              type: 1,
            })
            .then((res) => {
              if (res.code === 200) {
                // this.$message({
                //   message: res.data,
                //   type: "success",
                // });
                //this.$router.push("/Login");
                handleAlert("重置密码成功，请返回继续登录", "success");
                this.goLogin()
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
/* ===== 登录/忘记密码页字体：系统字体统一栈（2026-07-08 去掉阿里巴巴普惠体——Windows 未安装、只是摆设）=====
   .forget-page 页面与 .title/.btnlogin 现在用同一个 $puhui（$puhui-display 指向它），字体完全统一。
   Mac 命中 PingFang SC，Windows 命中微软雅黑；标题/按钮再叠 font-weight:300 走 Light 细体，
   "Microsoft YaHei Light" 前置：支持的 Chrome 直接用雅黑 Light face（对 Windows 变细是双保险）。 */
$puhui: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei Light", "微软雅黑 Light",
  "Microsoft YaHei", "微软雅黑", sans-serif;
$puhui-display: $puhui;

/* 所有样式收拢在 .forget-page 之下，避免非 scoped 样式污染其它页面 */
.forget-page {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: $puhui;
  -webkit-font-smoothing: antialiased; /* Mac 抗锯齿更细腻，配合 300 字重（Windows 用 DirectWrite 不受此属性影响）*/
  -moz-osx-font-smoothing: grayscale;
  /* 响应式基准单位（2026-07-08）：1920 宽时 = 1px，随视口宽度等比缩放，带上下限。
     卡片/输入框/间距/字体一律 calc(N * var(--px)) 跟随，整卡等比缩放。 */
  --px: clamp(0.7px, 0.05208vw, 1.12px);

  /* ===== 全屏背景视频：铺满、无遮罩、无间距 ===== */
  .bg-video {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    object-fit: cover;
    z-index: 0;
    margin: 0;
    padding: 0;
    border: none;
    display: block;
    pointer-events: none;
  }

  /* ===== 卡片容器：占据右半屏，卡片在其中水平垂直居中（卡片中心 = 视口 75% 处） ===== */
  .login-shell {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 calc(24 * var(--px));
    box-sizing: border-box;
  }

  /* ===== 高斯模糊玻璃卡片：圆角、透明、简约（尺寸随 --px 等比缩放） ===== */
  .glass-card {
    width: 100%;
    max-width: calc(420 * var(--px)); /* 1920→420px，随视口等比缩放 */
    padding: calc(36 * var(--px)) calc(32 * var(--px)) calc(32 * var(--px));
    box-sizing: border-box;

    background: rgba(255, 255, 255, 0.3);
    -webkit-backdrop-filter: blur(26px) saturate(150%);
    backdrop-filter: blur(26px) saturate(150%);
    border-radius: calc(20 * var(--px));
    border: 1px solid rgba(255, 255, 255, 0.55);
    box-shadow: 0 20px 60px rgba(8, 44, 92, 0.28),
      inset 0 1px 0 rgba(255, 255, 255, 0.6);
    animation: cardIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
  }

  /* el-form 本身透明，让玻璃质感透出来 */
  .login-container {
    width: 100%;
    background: transparent;
    box-sizing: border-box;

    /* 标题：白色、细字重（2026-07 定版由品牌蓝改白），单行显示 */
    .title {
      font-family: $puhui-display;
      font-size: calc(26 * var(--px));
      font-weight: 300; /* 雅黑/苹方各自的 Light 字重，两平台一致（400 会命中雅黑 Regular，Windows 明显偏粗）*/
      letter-spacing: calc(0.5 * var(--px));
      white-space: nowrap;
      text-align: center;
      margin: 0 auto calc(32 * var(--px));
      color: #fff;
    }

    .el-form-item {
      margin-bottom: calc(25 * var(--px)); /* 预留下方校验提示的空间：25 = 上6 + 提示13 + 下6，提示上下间距一致 */
    }
    /* 校验提示：定位使其在预留空间里上下间距一致（上 6px、下 6px）*/
    .el-form-item__error {
      position: absolute;
      top: 100%;
      left: 0;
      padding-top: calc(6 * var(--px));
      line-height: 1;
      color: rgba(255, 255, 255, 0.95); /* 校验提示白一点（原灰色看不清）；加投影保证在浅玻璃卡上清晰 */
      text-shadow: 0 1px 4px rgba(20, 40, 70, 0.5);
      font-size: calc(13 * var(--px));
      font-weight: 400;
    }
    .el-form-item__content {
      line-height: normal;
    }

    /* ===== 简洁胶囊输入框 =====
       注意：模板里的 id="input2" 会被 el-input 透传到原生 input 元素上（且多个输入框复用同一 id），
       #input2 的高度必须与 .el-input__inner 保持同值（50px），否则 id 权重（1,0,0）会压过类规则导致高度不齐。 */
    #input2 {
      height: calc(50 * var(--px));
    }

    .el-input__inner {
      height: calc(50 * var(--px));
      line-height: calc(50 * var(--px));
      border-radius: calc(26 * var(--px));
      border: 1px solid rgba(255, 255, 255, 0.7);
      background: rgba(255, 255, 255, 0.62); /* 原始半透明白（placeholder 恢复原样）*/
      color: #1a2b45;
      font-family: $puhui;
      font-size: calc(15 * var(--px));
      font-weight: 400;
      padding-left: calc(44 * var(--px));
      transition: all 0.25s ease;
      box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);

      &::placeholder {
        color: #5c6b82;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.75);
        border-color: rgba(12, 113, 207, 0.5);
      }
      &:focus {
        background: rgba(255, 255, 255, 0.9);
        border-color: #0c71cf;
        box-shadow: 0 0 0 3px rgba(12, 113, 207, 0.18);
      }
    }

    /* 禁用态输入框（获取短信前，验证码输入框禁用） */
    .el-input.is-disabled .el-input__inner {
      background: rgba(255, 255, 255, 0.35);
      border-color: rgba(255, 255, 255, 0.5);
      color: #8a97a8;
      cursor: not-allowed;

      &::placeholder {
        color: #9aa7b8;
      }
    }

    .el-input__prefix {
      left: calc(14 * var(--px));
      display: flex;
      align-items: center;
    }
    .el-input__icon {
      color: #0c71cf;
      font-size: calc(18 * var(--px));
      line-height: calc(50 * var(--px));
    }
    /* 显示密码 / 清除图标 */
    .el-input__suffix {
      right: calc(8 * var(--px));
    }
    .el-input__suffix .el-input__icon {
      font-size: calc(16 * var(--px));
      color: #5c6b82;
    }
  }

  /* ===== 验证码一行：输入框 + 获取验证码按钮 ===== */
  .codeBox {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      flex: 1;
    }

    .getCodeBtn {
      height: calc(50 * var(--px));
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-left: calc(12 * var(--px));
      flex-shrink: 0;
      padding: 0 calc(16 * var(--px));
      font-family: $puhui;
      font-size: calc(14 * var(--px));
      font-weight: 400;
      white-space: nowrap;
      border: none;
      border-radius: calc(26 * var(--px));
      color: #292929; /* 2026-07-08 定版：与登录按钮同款银蓝渐变+深灰字 */
      background: linear-gradient(135deg, #e2e7ec 0%, #c6e5e4 55%, #93b7dc 100%);
      box-shadow: 0 8px 18px rgba(20, 60, 110, 0.22);
      transition: filter 0.18s ease, box-shadow 0.18s ease;

      &:hover {
        filter: brightness(1.05);
      }
      &.is-disabled,
      &.is-disabled:hover {
        background: rgba(196, 196, 196, 0.55);
        color: #6b7280;
        box-shadow: none;
        filter: none;
        cursor: not-allowed;
      }
    }
  }

  /* ===== 重置密码按钮（30px / 400，与登录页一致） ===== */
  .center {
    margin-bottom: calc(14 * var(--px)) !important;
    text-align: center;
  }
  .btnlogin {
    width: 100%;
    height: calc(54 * var(--px));
    margin-top: calc(4 * var(--px));
    font-family: $puhui-display;
    font-size: calc(30 * var(--px));
    font-weight: 400; /* 按钮用 400（比标题略重、更清晰有力）；标题仍 300 */
    letter-spacing: calc(4 * var(--px));
    color: #292929;
    border: none;
    cursor: pointer;
    border-radius: calc(26 * var(--px));
    background: linear-gradient(135deg, #e2e7ec 0%, #c6e5e4 55%, #93b7dc 100%);
    box-shadow: 0 10px 24px rgba(20, 60, 110, 0.22);
    transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;

    &:hover {
      filter: brightness(1.04);
      box-shadow: 0 14px 30px rgba(20, 60, 110, 0.3);
      transform: translateY(-1px);
    }
    &:active {
      transform: translateY(0);
      box-shadow: 0 6px 16px rgba(20, 60, 110, 0.22);
    }
  }

  /* ===== 返回登录链接：突出、有间距 ===== */
  .tr {
    display: flex;
    justify-content: center;
    margin-top: 4px;
  }
  .toreturn {
    font-family: $puhui;
    font-size: calc(15 * var(--px));
    font-weight: 400;
    letter-spacing: calc(1 * var(--px));
    color: #fff; /* 2026-07-08 定版：白色（原品牌蓝） */
    cursor: pointer;
    padding: calc(8 * var(--px)) calc(6 * var(--px));
    transition: color 0.2s ease;

    &:hover {
      color: rgba(255, 255, 255, 0.85);
    }
  }

  /* ===== 底部版权信息：视频上清晰、突出、有间距 ===== */
  .biaoshi {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 28px;
    z-index: 3;
    text-align: center;
    font-family: $puhui;
    font-size: calc(14 * var(--px));
    font-weight: 400;
    letter-spacing: calc(1 * var(--px));
    line-height: 1.9;
    color: rgba(255, 255, 255, 0.92);
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.55);
    padding: 0 20px;
    pointer-events: none;
  }

  /* 中和 Chrome 自动填充的黄色背景 */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.62) inset;
    -webkit-text-fill-color: #1a2b45;
    caret-color: #1a2b45;
    transition: background-color 9999s ease-in-out 0s;
  }
}

/* ===== 卡片入场动画 ===== */
@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== 响应式：窄屏时右半屏放不下卡片，退回全屏居中 ===== */
@media (max-width: 900px) {
  .forget-page .login-shell {
    width: 100%;
    justify-content: center;
    padding: 0 24px;
  }
  .forget-page .login-container .title {
    font-size: calc(22 * var(--px));
    white-space: normal;
  }
}
/* 矮窗口：用 max-height 收紧留白（只压卡片 padding 和标题间距；
   不压 el-form-item 的 margin-bottom——否则下方校验提示会被挤没） */
@media (max-height: 760px) {
  .forget-page .glass-card {
    padding-top: 26px;
    padding-bottom: 24px;
  }
  .forget-page .login-container .title {
    margin-bottom: 24px;
  }
}
</style>
